import HttpCliente from '../services/HttpClient';
import axios from 'axios';

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const getNotaById = (id) => {
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`/api/notas/${id}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}
